import { render, staticRenderFns } from "./testads.vue?vue&type=template&id=517a7954&scoped=true"
import script from "./testads.vue?vue&type=script&lang=js"
export * from "./testads.vue?vue&type=script&lang=js"
import style0 from "./testads.vue?vue&type=style&index=0&id=517a7954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517a7954",
  null
  
)

export default component.exports